/**
 * This script add active class for the gravity forms inputs to make nice animation
 */
/* eslint-disable */
export const footerAddFormAnimationClass = () => {
	const inputsField = document.querySelectorAll(
		'footer .gform_body .gfield input'
	);

	if (inputsField && inputsField.length > 0) {
		Array.prototype.forEach.call(inputsField, (input) => {
			// if input have value after reload page, then input parent should be active
			if (input.value.length > 0) {
				input.parentElement.parentElement.classList.add('active');
			}

			input.addEventListener('click', () => addClassOnClick(input));
			input.removeEventListener('click', () => addClassOnClick(input));
			input.addEventListener('mousedown', () => addClassOnClick(input));
			input.removeEventListener('mousedown', () =>
				addClassOnClick(input)
			);
			input.addEventListener('focus', () => addClassOnClick(input));
			input.removeEventListener('focus', () => addClassOnClick(input));
		});
	}
};

/**
 * @param {HTMLElement} animateElement - gravity form input, we need to add class if the input is focused
 */
const addClassOnClick = (animateElement) => {
	if (animateElement === document.activeElement) {
		animateElement.parentElement.parentElement.classList.add('active');
	}

	const findActiveElement = document.querySelectorAll(
		'footer .gform_body .gfield.active input'
	);

	if (findActiveElement.length > 0) {
		Array.prototype.forEach.call(findActiveElement, (el) => {
			if (el !== animateElement && animateElement.value.length < 0) {
				el.parentElement.parentElement.classList.remove('active');
			}
		});
	}
};

const footerAddFormAnimationClassOutsideClick = (el) => {
	const activeFooterInputs = document.querySelectorAll(
		'footer .gform_body .gfield.active'
	);

	if (activeFooterInputs && activeFooterInputs.length > 0) {
		Array.prototype.forEach.call(activeFooterInputs, (input) => {
			if (
				el.target !== input.querySelector('input') &&
				input.querySelector('input').value.length <= 0
			) {
				input.classList.remove('active');
			}
		});
	}
};

document.addEventListener('click', (el) =>
	footerAddFormAnimationClassOutsideClick(el)
);
/* eslint-enable */
